/* AND — video stories (carousel + full-screen viewer) */
(function () {
  'use strict';
  var AND = window.AND || {};
  function money(c) {
    var v = (c / 100).toFixed(2).replace(/\.00$/, '');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' EGP';
  }
  var probe = document.createElement('video');
  var canHls = !!(probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl')) && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  document.querySelectorAll('[data-stories]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-stories-track]');
    var stories = Array.prototype.slice.call(root.querySelectorAll('[data-story]'));
    var viewer = root.querySelector('[data-viewer]');
    var video = viewer.querySelector('[data-viewer-video]');
    var bars = viewer.querySelector('[data-viewer-bars]');
    var productBox = viewer.querySelector('[data-viewer-product]');
    var muteBtn = viewer.querySelector('[data-viewer-mute]');
    var current = 0, muted = true, lastFocus = null;
    /* Lift the viewer out of the section so position:fixed is relative to the window */
    if (viewer.parentNode !== document.body) document.body.appendChild(viewer);

    /* ---------- carousel arrows ---------- */
    function page(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
    var prev = root.querySelector('[data-stories-prev]'), next = root.querySelector('[data-stories-next]');
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    var nav = root.querySelector('[data-stories-nav]'), bar = root.querySelector('[data-stories-bar]');
    function syncNav() {
      var max = track.scrollWidth - track.clientWidth;
      var vis = Math.max(track.clientWidth / Math.max(track.scrollWidth, 1), 0.12);
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (bar) { bar.style.width = vis * 100 + '%'; bar.style.transform = 'translateX(' + ratio * (100 / vis - 100) + '%)'; }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (nav) nav.classList.toggle('is-static', max <= 2);
    }
    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();

    /* ---------- silent previews ---------- */
    function startPreview(card) {
      var v = card.querySelector('.story__preview');
      if (!v) return;
      if (!v.src) v.src = (canHls && v.getAttribute('data-preview-hls')) || v.getAttribute('data-preview-src');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      card.classList.add('is-playing');
    }
    function stopPreview(card) {
      var v = card.querySelector('.story__preview');
      if (v && !v.paused) v.pause();
      card.classList.remove('is-playing');
    }
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (root.dataset.autoplay === 'true' && !reduce && !saveData && (canHls || canHover) && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (canHover) return; // desktop uses hover
          if (e.isIntersecting && e.intersectionRatio > 0.7) startPreview(e.target); else stopPreview(e.target);
        });
      }, { threshold: [0, 0.7, 1] });
      stories.forEach(function (c) { io.observe(c); });
    }
    if (canHover && !reduce) {
      stories.forEach(function (c) {
        c.addEventListener('mouseenter', function () { startPreview(c); });
        c.addEventListener('mouseleave', function () { stopPreview(c); });
      });
    }

    /* ---------- viewer ---------- */
    bars.innerHTML = stories.map(function () { return '<span><i></i></span>'; }).join('');
    var barEls = bars.querySelectorAll('i');

    function productHTML(card) {
      var j = card.querySelector('[data-story-product]');
      if (!j) return '';
      var p = JSON.parse(j.textContent);
      var avail = p.variants.filter(function (v) { return v.available; });
      var single = p.variants.length === 1;
      var sizes = single ? '' : '<div class="sv-sizes">' + p.variants.map(function (v) {
        return '<button type="button" class="sv-size' + (v.available ? '' : ' is-soldout') + '" data-sv-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      }).join('') + '</div>';
      var cta = avail.length
        ? '<button type="button" class="btn btn--wine sv-add" data-sv-add' + (single ? ' data-sv-default="' + p.variants[0].id + '"' : ' disabled') + '>' + (single ? 'Add to bag' : 'Pick a size') + '</button>'
        : '<a class="btn btn--chalk sv-add" href="' + p.url + '">Back soon · view</a>';
      return '<div class="sv-card">' +
        '<a class="sv-head" href="' + p.url + '"><img src="' + p.image + '" alt="" width="56" height="70"><span><b>' + esc(p.title) + '</b><span class="sv-price">' + money(p.price) + (p.compare > p.price ? ' <s>' + money(p.compare).replace(' EGP', '') + '</s>' : '') + '</span></span></a>' +
        (avail.length ? sizes : '') + cta + '<p class="sv-msg" hidden></p></div>';
    }

    function show(i) {
      if (i < 0) i = stories.length - 1;
      if (i >= stories.length) { close(); return; }
      current = i;
      var card = stories[i];
      video.poster = card.getAttribute('data-poster');
      video.src = (canHls && card.getAttribute('data-hls')) || card.getAttribute('data-src');
      video.muted = muted;
      var p = video.play(); if (p && p.catch) p.catch(function () { video.muted = true; muted = true; syncMute(); video.play().catch(function () {}); });
      Array.prototype.forEach.call(barEls, function (b, k) { b.style.width = k < i ? '100%' : '0%'; });
      var html = productHTML(card);
      productBox.innerHTML = html;
      productBox.hidden = !html;
    }
    function open(i) {
      lastFocus = document.activeElement;
      stories.forEach(stopPreview);
      viewer.hidden = false;
      void viewer.offsetWidth;
      viewer.classList.add('is-open');
      document.body.classList.add('has-drawer');
      show(i);
      var c = viewer.querySelector('[data-viewer-close].story-viewer__btn');
      if (c) c.focus();
    }
    function close() {
      video.pause();
      viewer.classList.remove('is-open');
      document.body.classList.remove('has-drawer');
      setTimeout(function () { viewer.hidden = true; video.removeAttribute('src'); video.load(); }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function syncMute() {
      viewer.classList.toggle('is-muted', muted);
      muteBtn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
    }
    syncMute();

    video.addEventListener('timeupdate', function () {
      if (video.duration) barEls[current].style.width = (video.currentTime / video.duration * 100) + '%';
    });
    video.addEventListener('ended', function () { show(current + 1); });
    video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-story-open]');
      if (opener) { e.preventDefault(); open(+opener.closest('[data-story]').getAttribute('data-index')); return; }
    });
    viewer.addEventListener('click', function (e) {
      if (e.target.closest('[data-viewer-close]')) { close(); return; }
      if (e.target.closest('[data-viewer-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-viewer-next]')) { show(current + 1); return; }
      if (e.target.closest('[data-viewer-mute]')) { muted = !muted; video.muted = muted; syncMute(); return; }
      var size = e.target.closest('[data-sv-variant]');
      if (size) {
        productBox.querySelectorAll('.sv-size').forEach(function (b) { b.classList.toggle('is-active', b === size); });
        var add = productBox.querySelector('[data-sv-add]');
        add.disabled = false; add.textContent = 'Add to bag'; add.setAttribute('data-sv-default', size.getAttribute('data-sv-variant'));
        return;
      }
      var addBtn = e.target.closest('[data-sv-add]');
      if (addBtn && addBtn.tagName === 'BUTTON') {
        var id = addBtn.getAttribute('data-sv-default');
        if (!id) return;
        addBtn.classList.add('is-loading');
        fetch((AND.routes ? AND.routes.cartAdd : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            close();
            if (window.ANDrefreshCart) window.ANDrefreshCart(true); else location.href = (AND.routes && AND.routes.cart) || '/cart';
          })
          .catch(function (er) {
            var m = productBox.querySelector('.sv-msg');
            if (m) { m.hidden = false; m.textContent = (er && er.description) || 'Could not add. Please try again.'; }
          })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') show(current + 1);
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') show(current - 1);
    });
    /* swipe */
    var sx = 0, sy = 0;
    viewer.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      if (e.target.closest('.story-viewer__product')) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) { if (dy < 0) show(current + 1); else if (dy > 120 && current === 0) close(); else show(current - 1); }
      else if (Math.abs(dx) > 60) { if (dx < 0) show(current + 1); else show(current - 1); }
    }, { passive: true });
  });
})();
